import {AnimatePresence, motion} from "framer-motion";

import {BrandCheckboxCheckedIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {HOMEMATCH_TINDER_SENT_LEAD_MESSAGE_CONTENT} from "../constants/homematch_tinder_content";
import {homematchTinderTweenTransition} from "../constants/homematch_tinder_motion";

import * as styles from "./HomematchTinderSentLeadMessage.module.css";

const SENT_LEAD_MESSAGE_MOTION_PROPS = {
    animate: {height: "auto", opacity: 1},
    exit: {height: 0, opacity: 0},
    initial: {height: 0, opacity: 0}
};

interface IProps {
    dataTestId?: string;
    isSentLeadMessageVisible: boolean;
    vendorName?: string;
}

export const HomematchTinderSentLeadMessage = (props: IProps) => {
    const {dataTestId, isSentLeadMessageVisible, vendorName} = props;

    return (
        <AnimatePresence initial={false}>
            {isSentLeadMessageVisible && (
                <motion.div className={styles.sentLeadMessageShell} transition={homematchTinderTweenTransition} {...SENT_LEAD_MESSAGE_MOTION_PROPS}>
                    <div className={styles.sentLeadMessageContent} data-testid={dataTestId}>
                        <BrandCheckboxCheckedIcon size="4.4" wrapperColor="var(--colors-primary)" wrapperSize="4.4" />

                        <div className={styles.textContent}>
                            <Text as="span" variant="headline_6">
                                {HOMEMATCH_TINDER_SENT_LEAD_MESSAGE_CONTENT.TITLE}
                            </Text>

                            {vendorName && (
                                <Text as="span" variant="info_txt_1">
                                    {HOMEMATCH_TINDER_SENT_LEAD_MESSAGE_CONTENT.getSubtitle(vendorName)}
                                </Text>
                            )}
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
import {AnimatePresence, motion} from "framer-motion";

import {BrandCheckboxCheckedIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {HOMEMATCH_TINDER_SENT_LEAD_MESSAGE_CONTENT} from "../constants/homematch_tinder_content";
import {homematchTinderTweenTransition} from "../constants/homematch_tinder_motion";

import * as styles from "./HomematchTinderSentLeadMessage.module.css";

const SENT_LEAD_MESSAGE_MOTION_PROPS = {
    animate: {height: "auto", opacity: 1},
    exit: {height: 0, opacity: 0},
    initial: {height: 0, opacity: 0}
};

interface IProps {
    dataTestId?: string;
    isSentLeadMessageVisible: boolean;
    vendorName?: string;
}

export const HomematchTinderSentLeadMessage = (props: IProps) => {
    const {dataTestId, isSentLeadMessageVisible, vendorName} = props;

    return (
        <AnimatePresence initial={false}>
            {isSentLeadMessageVisible && (
                <motion.div className={styles.sentLeadMessageShell} transition={homematchTinderTweenTransition} {...SENT_LEAD_MESSAGE_MOTION_PROPS}>
                    <div className={styles.sentLeadMessageContent} data-testid={dataTestId}>
                        <BrandCheckboxCheckedIcon size="4.4" wrapperColor="var(--colors-primary)" wrapperSize="4.4" />

                        <div className={styles.textContent}>
                            <Text as="span" variant="headline_6">
                                {HOMEMATCH_TINDER_SENT_LEAD_MESSAGE_CONTENT.TITLE}
                            </Text>

                            {vendorName && (
                                <Text as="span" variant="info_txt_1">
                                    {HOMEMATCH_TINDER_SENT_LEAD_MESSAGE_CONTENT.getSubtitle(vendorName)}
                                </Text>
                            )}
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
